<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  bordered
                  class="datatables"
                  :fields="fields"
                  :items="labResultOptions"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered">
                <template #cell(index)="data">
                  {{data.index+1}}
                </template>
                <template #cell(option)="data">
                  <!-- DEFINED -->
                  <table class="table" v-if="data.item.resultType==1">
                    <thead>
                    <tr>
                      <th>OPTION</th>
                      <th>CODE</th>
                      <th>SYMBOL</th>
                      <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(option, o) in data.item.options" :key="o">
                      <td>{{option.result_name}}</td>
                      <td>{{option.result_code}}</td>
                      <td>{{option.result_symbol}}</td>
                      <td>
                        <!-- Edit Modal -->
                        <b-button v-if="user_permissions.edit_test_option" v-b-modal.edit-option @click="editModal(option)" size="sm" variant="primary"><i
                            class="fa fa-edit"></i>
                          Edit</b-button>
                          <b-button v-else disabled v-b-modal.edit-option @click="editModal(option)" size="sm" variant="primary"><i
                            class="fa fa-edit"></i>
                          Edit</b-button>
                        |
                        <!-- Delete Modal -->
                        <b-button v-if="user_permissions.delete_test_option" v-b-modal.delete-option @click="deleteModal(option)" size="sm" variant="danger" ><i
                            class="fa fa-trash"></i>
                          Delete</b-button>
                          <b-button v-else disabled v-b-modal.delete-option @click="deleteModal(option)" size="sm" variant="danger" ><i
                            class="fa fa-trash"></i>
                          Delete</b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- UNDEFINED -->
                  <table class="table" v-if="data.item.resultType==2">
                    <thead>
                    <tr>
                      <th>No Options for <code>{{data.item.serviceName}}</code>. It has undefined result options</th>
                    </tr>
                    </thead>
                  </table>

                  <!-- MACHINE -->
                  <table class="table" v-if="data.item.resultType==3">
                    <thead>
                    <tr>
                      <th>No Options for <code>{{data.item.serviceName}}</code>. It is a machine based test </th>
                    </tr>
                    </thead>
                  </table>

                  <!-- PARAMETER -->
                  <table class="table" v-if="data.item.resultType==4">
                    <thead>
                    <tr>
                      <th>PARAMETER</th>
                      <th>AGE</th>
                      <th>SEX</th>
                      <th>RANGE</th>
                      <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(option, o) in data.item.options" :key="o">
                      <td>{{option.result_name}}</td>
                      <td>{{option.age_start}}-{{option.age_end}}</td>
                      <td>{{option.gender}}</td>
                      <td>{{option.start}}-{{option.end}} <strong><em>{{option.unit}}</em></strong></td>
                      <td>
                        <!-- Edit Modal -->
                        <b-button v-if="user_permissions.edit_test_option" v-b-modal.edit-parameter @click="editModal(option)" size="sm" variant="primary"><i class="fa fa-edit"></i>
                          Edit</b-button>
                          <b-button v-else disabled v-b-modal.edit-parameter @click="editModal(option)" size="sm" variant="primary"><i class="fa fa-edit"></i>
                          Edit</b-button>
                        |
                        <!-- Delete Modal -->
                        <b-button v-if="user_permissions.delete_test_option" v-b-modal.delete-parameter @click="deleteModal(option)" size="sm" variant="danger"
                        ><i class="fa fa-trash"></i> Delete</b-button>
                        <b-button v-else disabled v-b-modal.delete-parameter @click="deleteModal(option)" size="sm" variant="danger"
                        ><i class="fa fa-trash"></i> Delete</b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- CULTURE -->
                  <table class="table" v-if="data.item.resultType==5">
                    <thead>
                    <tr>
                      <th>No Options for <code>{{data.item.serviceName}}</code>. It is a culture and sensitivity test
                      </th>
                    </tr>
                    </thead>
                  </table>
                </template>
                <template #cell(action)="data">
                  <span v-if="data.item.resultType==1 || data.item.resultType==4">
                     <b-button v-b-modal.add-option v-if="data.item.resultType==1 && user_permissions.add_test_option" @click="definedModal(data)"
                               title="Add new result option"
                               size="sm"
                                variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
                    <b-button v-b-modal.add-parameter v-if="data.item.resultType==4 && user_permissions.add_test_option" @click="parameterModal(data)"
                              title="Add new parameter option" size="sm"
                              variant="primary"><i class="fa fa-plus"></i> Add
                    New</b-button>
                  </span>
                </template>
              </b-table>
                <h3 v-if="!labResultOptions" class="text-primary text-center">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
            </div>
          </div>
        </div>
      </div>
      <!--ADD RESULT OPTION -->
      <b-modal id="add-option" ref="modal" hide-footer @hidden="resetDefinedModal">
        <template #modal-title>
          <p class="text-uppercase">Add result option for {{definedData.test}}</p>
        </template>
          <div class="mb-2">
            <label class="col-form-label" for="name">Option Name e.g Reactive</label>
            <input id="name" @keyup="checkName" class="form-control" type="text" v-model="definedData.resultName">
            <div class="text-danger" v-if="optionError">
              <em>{{ optionError }}</em>
            </div>
          </div>
        <div class="mb-2">
            <label class="col-form-label" for="code">Result encryption code (Optional)</label>
            <input id="code" class="form-control" type="text" v-model="definedData.resultCode">
          </div>
        <div class="mb-2">
          <label class="col-form-label" for="symbol">Option Symbol e.g (+)</label>
          <input id="symbol" class="form-control" type="text" v-model="definedData.resultSymbol">
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="$bvModal.hide('add-option')" type="button">Close
          </button>
          <button v-if="existingOption.length" class="btn btn-info" disabled title="This Item already exists"
                  type="button"><i class="fa fa-ban"></i> Save
          </button>
          <button v-else class="btn btn-primary" @click="saveOption('add-option')" type="button">
            Save option
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!--ADD RESULT OPTION -->

      <!--ADD PARAMETER OPTION -->
      <b-modal id="add-parameter" ref="modal" hide-footer @hidden="resetParameterModal">
        <template #modal-title>
          <p class="text-uppercase">Add parameter for {{parameterData.test}}</p>
        </template>
        <div class="mb-2">
          <label class="col-form-label" for="parameter">Parameter Name e.g White blood cell (WBC)</label>
          <input id="parameter" @keyup="checkParameter" class="form-control" type="text" v-model="parameterData.resultName">
          <div class="text-danger" v-if="parameterError">
            <em>{{ parameterError }}</em>
          </div>
        </div>
        <div class="mb-2">
          <label class="col-form-label" for="gender">Gender (Both/Male Only/Female Only)</label>
          <select id="gender" class="form-control" v-model="parameterData.gender">
            <option value="Both">Both</option>
            <option value="Male">Male Only</option>
            <option value="Female">Female Only</option>
          </select>
        </div>
        <div class="mb-2">
          <label class="col-form-label">Age Range ( e.g 0.0 - 120.0 yrs)</label>
          <div class="row">
            <div class="col">
              <input class="form-control" placeholder="Lower age" type="text" v-model="parameterData.age_start">
            </div>
            <div class="col">
              <input class="form-control" placeholder="Higher age" type="text" v-model="parameterData.age_end">
            </div>
          </div>
        </div>
        <div class="mb-2">
          <label class="col-form-label">Reference Interval ( e.g 4.0 - 12.0 K/mcL)</label>
          <div class="row">
            <div class="col">
              <input class="form-control" placeholder="Lower Interval" type="text" v-model="parameterData.lowerInterval">
            </div>
            <div class="col">
              <input class="form-control" placeholder="Higher Interval" type="text" v-model="parameterData.higherInterval">
            </div>
            <div class="col">
              <input class="form-control" placeholder="unit" type="text" v-model="parameterData.intervalUnit">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="$bvModal.hide('add-parameter')" type="button">Close
          </button>
          <button v-if="existingOption.length" class="btn btn-info" disabled title="This Item already exists"
                  type="button"><i class="fa fa-ban"></i> Save
          </button>
          <button v-else class="btn btn-primary" @click="saveParameter('add-parameter')" type="button">
            Save parameter
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!--ADD PARAMETER OPTION -->

      <!-- EDIT RESULT OPTION -->
      <b-modal id="edit-option" ref="modal" hide-footer @hidden="resetEditModal">
        <template #modal-title>
          <p class="text-uppercase">Update {{ editData.resultName }}</p>
        </template>
        <div class="mb-2">
          <label class="col-form-label" for="edit-name">Option Name e.g Reactive</label>
          <input id="edit-name" class="form-control" type="text" v-model="editData.resultName">
          <div class="text-danger" v-if="optionError">
            <em>{{ optionError }}</em>
          </div>
        </div>
        <div class="mb-2">
          <label class="col-form-label" for="edit-code">Result encryption code (Optional)</label>
          <input id="edit-code" class="form-control" type="text" v-model="editData.resultCode">
        </div>
        <div class="mb-2">
          <label class="col-form-label" for="edit-symbol">Option Symbol e.g (+)</label>
          <input id="edit-symbol" class="form-control" type="text" v-model="editData.resultSymbol">
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary"  @click="$bvModal.hide('edit-option')" type="button">Close</button>
          <button class="btn btn-primary" type="button" @click="editOption('edit-option')">
            Save Changes
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- EDIT RESULT OPTION -->

      <!--EDIT PARAMETER OPTION -->
      <b-modal id="edit-parameter" ref="modal" hide-footer @hidden="resetParameterModal">
        <template #modal-title>
          <p class="text-uppercase">Add parameter for {{editData.test}}</p>
        </template>
        <div class="mb-2">
          <label class="col-form-label">Parameter Name e.g White blood cell (WBC)</label>
          <input @keyup="checkParameter" class="form-control" type="text" v-model="editData.resultName">
        </div>
        <div class="mb-2">
          <label class="col-form-label">Gender (Both/Male Only/Female Only)</label>
          <select class="form-control" v-model="editData.gender">
            <option value="Both">Both</option>
            <option value="Male">Male Only</option>
            <option value="Female">Female Only</option>
          </select>
        </div>
        <div class="mb-2">
          <label class="col-form-label">Age Range ( e.g 0.0 - 120.0 yrs)</label>
          <div class="row">
            <div class="col">
              <input class="form-control" placeholder="Lower age" type="text" v-model="editData.age_start">
            </div>
            <div class="col">
              <input class="form-control" placeholder="Higher age" type="text" v-model="editData.age_end">
            </div>
          </div>
        </div>
        <div class="mb-2">
          <label class="col-form-label">Reference Interval ( e.g 4.0 - 12.0 K/mcL)</label>
          <div class="row">
            <div class="col">
              <input class="form-control" placeholder="Lower Interval" type="text" v-model="editData.lowerInterval">
            </div>
            <div class="col">
              <input class="form-control" placeholder="Higher Interval" type="text" v-model="editData.higherInterval">
            </div>
            <div class="col">
              <input class="form-control" placeholder="unit" type="text" v-model="editData.intervalUnit">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="$bvModal.hide('edit-parameter')" type="button">Close
          </button>
          <button v-if="existingOption.length" class="btn btn-info" disabled title="This Item already exists"
                  type="button"><i class="fa fa-ban"></i> Save
          </button>
          <button v-else class="btn btn-primary" @click="editOption('edit-parameter')" type="button">
            Save parameter
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!--EDIT PARAMETER OPTION -->

      <!-- DELETE RESULT OPTION -->
      <b-modal id="delete-option" ref="modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <p class="text-uppercase">Delete {{ deleteData.resultName }}</p>
        </template>
        <h3 class="text-center">
          Are you sure to delete <code>{{ deleteData.resultName }}</code> result option? <br>
          Click <code>REMOVE</code> to continue.
        </h3>
        <div class="modal-footer">
          <button class="btn btn-secondary"  @click="$bvModal.hide('delete-option')" type="button">Close</button>
          <button class="btn btn-danger" type="button" @click="deleteOption('delete-option')">
            Remove
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- DELETE RESULT OPTION -->

      <!-- DELETE RESULT OPTION -->
      <b-modal id="delete-parameter" ref="modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <p class="text-uppercase">Delete {{ deleteData.resultName }}</p>
        </template>
        <h3 class="text-center">
          Are you sure to delete <code>{{ deleteData.resultName }}</code> result option? <br>
          Click <code>REMOVE</code> to continue.
        </h3>
        <div class="modal-footer">
          <button class="btn btn-secondary"  @click="$bvModal.hide('delete-parameter')" type="button">Close</button>
          <button class="btn btn-danger" type="button" @click="deleteOption('delete-parameter')">
            Remove
            <b-spinner
                v-if="ServiceStatus"
                variant="light" small
                role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- DELETE RESULT OPTION -->

    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import {mapGetters, mapActions, mapState} from "vuex";

export default {
  page: {
    title: "Tests Result Options",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Tests Result Options",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Tests Result Options",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "serviceName",
          sortable: true,
          label: "SERVICE NAME",
        },
        {
          key: "option",
          sortable: true,
          label: "RESULT OPTIONS & PARAMETERS",
        },
        {
          key: "action",
          sortable: true,
          label: "ACTION",
        },
      ],
      modal_id:"",
      optionError:"",
      parameterError:"",
      definedData:{
        id:"",
        test:"",
        resultName:"",
        resultCode:"",
        resultSymbol:"",
        lowerInterval:"",
        intervalUnit:"",
        higherInterval:"",
        gender:"",
        age_start:"",
        age_end:"",
      },
      parameterData:{
        id:"",
        test:"",
        resultName:"",
        resultCode:"",
        resultSymbol:"",
        lowerInterval:"",
        intervalUnit:"",
        higherInterval:"",
        gender:"Both",
        age_start:"",
        age_end:"",
      },
      editData:{
        id:"",
        resultName:"",
        resultCode:"",
        resultSymbol:"",
        lowerInterval:"",
        intervalUnit:"",
        higherInterval:"",
        gender:"",
        age_start:"",
        age_end:"",
      },
      deleteData:{
        id:"",
        resultName:"",
      },
      existingOption: [],
    };
  },

  computed: {
    ...mapGetters("services", ["labResultOptions","resultOptions","ServiceStatus"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("auth", ["user_permissions"]),

    rows() {
      return this.labResultOptions ? this.labResultOptions.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.labResultOptions ? this.labResultOptions.length : 1;
  },
  watch: {
    notification_show(newValue) {
      if (newValue === true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype === "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchResultOptions: "services/fetchResultOptions",
      fetchOptions: "services/fetchOptions",
      submitOption: "services/saveResultOption",
      deleteResultOption: "services/deleteResultOption",
      editResultOption: "services/updateResultOption",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkParameter() {
      //when creating a new one
      if (this.parameterData.resultName != "") {
        this.existingOption = this.resultOptions.filter((option) => {
          return option.result_name == this.parameterData.resultName && option.labtest_id == this.parameterData.id;
        });
        if (this.existingOption.length) {
          this.parameterError = this.parameterData.resultName + " exists already";
        } else {
          this.parameterError = ""
        }
      } else {
        this.existingOption = [];
      }
    },

    checkName() {
      //when creating a new one
      if (this.definedData.resultName != "") {
        this.existingOption = this.resultOptions.filter((option) => {
          return option.result_name == this.definedData.resultName && option.labtest_id == this.definedData.id;
        });
        if (this.existingOption.length) {
          this.optionError = this.definedData.resultName + " exists already";
        } else {
          this.optionError = ""
        }
      } else {
        this.existingOption = [];
      }
    },

  //  SHOW ADD PARAMETER MODAL
    parameterModal(data){
      this.parameterData.test=data.item.serviceName
      this.parameterData.id=data.item.id
    },
    saveParameter(modalId){
      this.modal_id=modalId;

      if (this.parameterData.resultName=="" || this.parameterData.resultName==null){
        this.parameterError = "Parameter Name field is required";
        return;
      }else {
        this.parameterError ="";
      }

      //dispatch to the endpoint
      this.submitOption(this.parameterData);
    },

    resetParameterModal(){
      this.parameterData.test=""
      this.parameterData.id=""
      this.parameterData.resultName=""
      this.parameterData.higherInterval=""
      this.parameterData.lowerInterval=""
      this.parameterData.age_end=""
      this.parameterData.age_start=""
      this.parameterData.gender="Both"
      this.parameterError=""
    },

    //  SHOW ADD DEFINED RESULT OPTIONS MODAL
    definedModal(data){
      this.definedData.test=data.item.serviceName
      this.definedData.id=data.item.id
    },
    saveOption(modalId){
      this.modal_id=modalId;

      if (this.definedData.resultName=="" || this.definedData.resultName==null){
        this.optionError = "Option Name field is required";
        return;
      }else {
        this.optionError ="";
      }

      //dispatch to the endpoint
      this.submitOption(this.definedData);
    },
    resetDefinedModal(){
      this.definedData.test=""
      this.definedData.id=""
      this.definedData.resultName=""
      this.definedData.resultSymbol=""
      this.definedData.resultCode=""
      this.optionError=""
    },

    //  SHOW DELETE DEFINED RESULT OPTIONS MODAL
    deleteModal(option){
      this.deleteData.resultName=option.result_name
      this.deleteData.id=option.id
    },
    deleteOption(modalId){
      this.modal_id=modalId;

      //dispatch to the endpoint
      this.deleteResultOption(this.deleteData);
    },
    resetDeleteModal(){
      this.deleteData.resultName=""
      this.deleteData.id=""
    },

    //  SHOW EDIT DEFINED RESULT OPTIONS MODAL
    editModal(option){
      this.editData.resultName=option.result_name
      this.editData.resultSymbol=option.result_symbol
      this.editData.resultCode=option.result_code
      this.editData.id=option.id
      this.editData.age_start=option.age_start
      this.editData.age_end=option.age_end
      this.editData.higherInterval=option.end
      this.editData.lowerInterval=option.start
      this.editData.intervalUnit=option.unit
      this.editData.gender=option.gender
    },

    editOption(modalId){
      this.modal_id=modalId;

      if (this.editData.resultName=="" || this.editData.resultName==null){
        this.optionError = "Option Name field is required";
        return;
      }else {
        this.optionError ="";
      }

      //dispatch to the endpoint
      this.editResultOption(this.editData);
    },
    resetEditModal(){
      this.editData.resultName=""
      this.editData.resultSymbol=""
      this.editData.resultCode=""
      this.editData.id=""
      this.editData.age_start=""
      this.editData.age_end=""
      this.editData.higherInterval=""
      this.editData.lowerInterval=""
      this.editData.intervalUnit=""
      this.editData.gender=""
      this.optionError=""
    },




    // CLOSE MODEL
    closeModal(modelId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modelId);
      });
    },
  },

  created() {
    this.fetchResultOptions();
    this.fetchOptions();
  },
};
</script>

<style lang="css" scoped>
</style>